import useTranslation from 'next-translate/useTranslation'
import Head from 'next/head'
import { RecipeDetail } from 'features/Recipes/RecipeDetail/RecipeDetail'
import Script from 'next/script'
export default function RecipePage() {
  const { t } = useTranslation()

  // prettier-ignore
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Recipe',
    name: 'Beef Patty Recipe',
    description:
      'One of our best-selling single-protein recipes, beef is a highly nutritious source of essential amino acids, vitamins, and minerals. Complete + balanced for dogs of all life stages. Formulated by a Phd nutritionist.',
    image: 'https://wefeedraw.com/assets/recipes/categories/individual/hero-beef.png',
    author: {
      '@type': 'Organization',
      name: 'We Feed Raw'
    },
    publisher: {
      '@type': 'Organization',
      name: 'We Feed Raw',
      logo: {
        '@type': 'ImageObject',
        url: 'https://wefeedraw.com/assets/isotype-background-brown.svg'
      }
    },
    recipeCategory: 'Raw Dog Food',
    recipeCuisine: 'Pet Food',
    prepTime: 'PT1M',
    cookTime: 'PT0M',
    recipeYield: 'Yield varies based on the size and dietary needs of your dog',
    keywords: 'raw dog food beef',
    recipeIngredient: [
      'Beef Heart',
      'Beef Liver',
      'Beef Kidney',
      'Beef Necks (with bone)',
      'WFR vitamin + mineral mix'
    ],
    nutrition: {
      '@type': 'NutritionInformation',
      calories: '51 kcal M.E./oz',
      proteinContent: '(min) 12.2%',
      fatContent: '(min) 10.0%',
      fiberContent: '(max) 1.0%',
      additionalProperty: [
        {
          '@type': 'PropertyValue',
          name: 'Calories per kg',
          value: '1800 kcal M.E./kg'
        }
      ]
    }
  };

  const jsonLdString = JSON.stringify(schema)

  return (
    <div>
      <Head>
        <title>{t('recipes:beef.page-title')}</title>
        <meta name="title" content={t('recipes:beef.meta-title')} />
        <meta name="description" content={t('recipes:beef.meta-description')} />
        <link rel="canonical" href="https://wefeedraw.com/recipes/beef" />
      </Head>
      <Script
        id="schema-script"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLdString }}
      />
      <main>
      <Script
        id="schema-script"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLdString }}
      />
        <RecipeDetail recipe="beef" />
      </main>
    </div>
  )
}
